import { useState } from 'react';
import * as S from './style';
//components
import BarcodeExport from '../../components/BarcodePng';
import ToastSale from '../../components/ToastSale';
import DeleteAll from '../DeleteAll';
import CreatePromotion from '../Modals/Promotion/Create';
import Toast from '../Toast';
//context
import { useCart } from 'context/CartContex';
//hooks
import { useMultipleModal } from '../../hooks/useMultipleModal';
//icons
import {
    Checks,
    SealPercent,
    ShoppingCartSimple,
    Tag,
    Trash,
} from "@phosphor-icons/react";

// Tipos
interface Product {
    id: string;
    code: string;
    type: string;
    amount: number;
    price: number;
    name?: string;
    // Outros campos necessários
    name_lens?: string
}
interface ITopActionBar {
    idSelecteds: number[];
    typeProduct: string;

    urlFilter?: {};
    fetchData: () => void;
    nameDeleteAll: string;
    handleDeleteResponse: (status: number) => void;
    isPromo?: boolean,
    isTag?: boolean,
    isCart?: boolean,
    itemsTag?: {
        barcode: string,
        code: string,
        brands?: string,
        price: string
    }[];
    selectedProducts?: Product[]; // Nova prop com os dados completos
}

export default function TopActionBar({
    idSelecteds,
    typeProduct,
    urlFilter,
    fetchData,
    nameDeleteAll,
    handleDeleteResponse,
    isPromo = false,
    isTag = false,
    isCart = false,
    itemsTag = [],
    selectedProducts
}: ITopActionBar) {

    const [hoveredButton, setHoveredButton] = useState<string | null>(null);
    const { isOpenModal, toggleModalVisibility } = useMultipleModal();
    const [toastData, setToastData] = useState({
        status: 200,
        message: "",
    });
    const { addToCart } = useCart();

    // Função para adicionar produtos ao carrinho
    const handleAddToCart = () => {
        // Verificar se há produtos selecionados
        if (!selectedProducts || selectedProducts.length === 0) {
            setToastData({
                message: 'Nenhum produto selecionado!',
                status: 400
            });
            toggleModalVisibility('open-toast-sale');
            return;
        }

        // Verificar estoque para todos os produtos
        const productsWithoutStock = selectedProducts.filter(product => product.amount <= 0);
        if (productsWithoutStock.length > 0) {
            setToastData({
                message: `${productsWithoutStock.length} produto(s) sem estoque!`,
                status: 400
            });
            toggleModalVisibility('open-toast-sale');
            return;
        }

        try {
            let addedCount = 0;
            let firstProductCode = '';

            // Adicionar cada produto ao carrinho
            selectedProducts.forEach((product, index) => {
                console.log('product: ', product);
                addToCart(product);
                addedCount++;
                if (index === 0) {
                    firstProductCode = product.code;
                }
            });

            // Mensagem de sucesso
            const message = addedCount === 1
                ? `${firstProductCode} adicionado ao carrinho!`
                : `${addedCount} produtos adicionados ao carrinho!`;

            setToastData({
                message: message,
                status: 200
            });
            toggleModalVisibility('open-toast-sale');

        } catch (error) {
            console.error('Erro ao adicionar produto:', error);
            setToastData({
                message: 'Erro ao adicionar produto(s) ao carrinho!',
                status: 500
            });
            toggleModalVisibility('open-toast-sale');
        }
    };

    const DeleteAllModal = () => {
        toggleModalVisibility("deleteAll");
    };

    const menuActionBar = [
        {
            key: "delete",
            isVisible: true,
            isActive: true,
            title: "Excluir",
            icon: Trash,
            action: DeleteAllModal,
        },
        {
            key: "promo",
            isVisible: isPromo,
            isActive: false,
            title: "Promoção",
            icon: SealPercent,
            action: () => toggleModalVisibility("open-promotion"),
        },
        {
            key: "tag",
            isVisible: isTag,
            isActive: false,
            title: "Etiqueta",
            icon: Tag,
            action: () => toggleModalVisibility("barcode"),
        },
        {
            key: "cart",
            isVisible: isCart,
            isActive: false,
            title: "Carrinho",
            icon: ShoppingCartSimple,
            action: handleAddToCart,
        },
    ];

    return (
        <S.Container>
            <S.Content>
                {
                    menuActionBar
                        .filter((menu) => menu.isVisible) // só renderiza os que devem aparecer
                        .map((menu) => {
                            const Icon = menu.icon;

                            return (
                                <S.Button
                                    key={menu.key}
                                    isActive={menu.isActive}
                                    onMouseEnter={() => setHoveredButton(menu.key)}
                                    onMouseLeave={() => setHoveredButton(null)}
                                    onClick={menu.action}
                                >
                                    {hoveredButton === menu.key ? (
                                        <Icon size={24} weight="fill" />
                                    ) : (
                                        <Icon size={24} />
                                    )}
                                    <S.Title>{menu.title}</S.Title>
                                </S.Button>
                            );
                        })}
            </S.Content>

            <S.Subtitle>
                <Checks size={12} />
                {idSelecteds.length} selecionado(s)
            </S.Subtitle>

            {/* MODALS */}
            {
                urlFilter &&
                <CreatePromotion
                    isOpenModalAcessory={isOpenModal("open-promotion")}
                    setModalClose={() => toggleModalVisibility("open-promotion")}

                    idProducts={idSelecteds}
                    type_product={typeProduct}
                    urlProduct={urlFilter}

                    setToastOpen={() => toggleModalVisibility('open-toast')}
                    setToastData={setToastData}
                />
            }
            <Toast
                openToast={isOpenModal('open-toast')}
                closeToast={() => toggleModalVisibility('open-toast')}
                message={toastData.message}
                status={toastData.status}
            />
            <ToastSale
                openToast={isOpenModal('open-toast-sale')}
                closeToast={() => toggleModalVisibility('open-toast-sale')}
                message={toastData.message}
                status={toastData.status}
                cartItemsCount={idSelecteds.length}
            />
            <DeleteAll
                setResponse={handleDeleteResponse}
                updateList={fetchData}
                data={idSelecteds}
                endpoint={nameDeleteAll}
                isOpenModal={isOpenModal("deleteAll")}
                setModalClose={() => toggleModalVisibility("deleteAll")}
            />
            <BarcodeExport
                isOpenBarcode={isOpenModal("barcode")}
                setModalClose={() => toggleModalVisibility("barcode")}
                itemsTag={itemsTag}
            />
        </S.Container>
    )
}